var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tournament)?_c('BaseLink',{attrs:{"to":{
    name: 'tournament',
    params: { id: _vm.tournament.urlCode || _vm.tournament.id },
  },"title":`${_vm.$t('tournaments.single')} ${_vm.tournament.name}`}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.tournament.name))]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }